import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const ActivationEnergy = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Concept of Activation Energy"
    videos={[
      "https://www.youtube.com/embed/jX4dEOFwaLQ",
      "https://www.youtube.com/embed/pPtYUIoLBu8",
    ]}
    takeaways={[
      { text: "Numerical based question is asked related to Arrhenius equation and activation energy both in CAT and FAT." },
      { text: "A conceptual question can be asked from the topic of collision theory and activation energy." },
    ]}
    questions={[
      "Derive the rate expression for conversion methyl isonitrile to acetronitrile. How can we calculate the rate constant for this reaction using graphical method?",
      "How is Arrhenius equation related to collision theory? Explain how the geometry of an activated complex is different from those of reactant and product with an example.",
      "Substance A with an initial concentration of 10 M undergoes decomposition following first order kinetics. After 23 min the concentration becomes 1M. Calculate half-life period of the reaction.",
      "A first order reaction takes 9 hours for 80% completion. Calculate the time required for 95% completion.",
      "List on the necessary experimental data required to evaluate the activation energy. Which equation is applicable to calculate it showing the appropriate plot?"
    ]}
    exampleVideos={[]}
  />
);
}

export default ActivationEnergy;
